import React, { useContext } from "react";
import { firestore } from '../firebase.js';
import { UserContext } from "../Providers/UserProvider";
import UserCard from '../Components/UserCard';
import '../Styles/Sass/Admin.scss';

function Admin(){
  // const [allCleaners, setCleaners] = React.useState([]);
  // const [allEmployers, setEmployers] = React.useState([]);
  const [allUsers, setUsers] = React.useState([]);
  const [jobFilters, setJobFilters] = React.useState('all');
  const [verificationFilters, setVerificationFilters] = React.useState('all');
  const [filteredUsers, setFilteredUsers] = React.useState([]);

  React.useEffect(() => {
    setAllUsers();
  }, []);

  const setAllUsers = () => {
    firestore.collection('users').get()
      .then(users => {
        const userContainer = [];
        users.docs.forEach(doc => {
          userContainer.push({
            user: doc.data(),
            userId: doc.id
          })
        });
        setUsers(userContainer);
      })
      .catch(err => {
        console.log(err);
      })
  }

  const verifyUser = (userID, verificationKey, verified, job) => {
    firestore.collection("users").doc(userID).update({
      [verificationKey]: !verified
    })
      .then(res => {
        setAllUsers();
      })
      .catch(err => {
        console.log(err);
      });
  }

  const filterUsers = (filter) => {
    setJobFilters(filter);
    console.log(jobFilters);
    if (jobFilters !== 'all') {
      let newList = allUsers.filter(user => {
        return (user.user.job === jobFilters);
      });
      setFilteredUsers(newList);
    }
  }

  const renderUsers = (userGroup, job) => {
    const render = userGroup.map(user => {
      return (
        <UserCard
          key={user.userId}
          userId={user.userId}
          name={user.user.name}
          email={user.user.email}
          job={user.user.job}
          verified={user.user.verified}
          whimis={user.user.whimis}
          policecheck={user.user.policecheck}
          verifyUser={verifyUser}
          uploads={user.user.uploads}
        />
      );
    })
    return render;
  }

  const user = useContext(UserContext);

  return(
    <section className='admin'>
      <h3 className='admin__title'>User Database</h3>
      <div className='admin__filterbox'>
        <div className='filterbox'>
          <h4 className='filterbox__title'>Job Filter</h4>
          <button
            className='filterbox__button'
            onClick={() => setJobFilters('all')}
          >
            All
          </button>
          <button
            className='filterbox__button'
            onClick={() => setJobFilters('cleaner')}
          >
            Cleaners
          </button>
          <button
            className='filterbox__button'
            onClick={() => setJobFilters('employer')}
          >
            Employers
          </button>
        </div>
        <div className='filterbox'>
          <h4>Verification Filter</h4>
          <button
            className='filterbox__button'
            onClick={() => setVerificationFilters('all')}
          >
            All
          </button>
          <button
            className='filterbox__button'
            onClick={() => setVerificationFilters('verification')}
          >
            Needs Verification
          </button>
        </div>
      </div>
      <ul className='admin__list'>
        {renderUsers(allUsers)}
      </ul>
    </section>
  );
}

export default Admin;